export default "/app/global-wrapper-client/static/a90f9868c194b0eb8c8e2f49ddda5ce5.woff2";